<template>
  <div class="card-info-produto-repeticao">
    <!-- <div class="titulo-fluxos"> INFORMAÇÕES DO CLIENTE </div>
    <div class="subtitulo-fluxos"> Confirme as informações do cliente antes de continuar </div> -->
    <g-titulo-steps
    titulo="INFORMAÇÕES DO CLIENTE"
    subtitulo="Confirme as informações do cliente antes de continuar"
    :imagemEmpresa = imagemEmpresa
    />

    <div class="header-infoCliente-btnEditar">
      <g-button
      class="btn-editar"
      altura="35px"
      largura="35px"
      tamanhoIcone="20px"
      icone="icone_editar.svg"
      @click="aparecerpopup()"
      >
      </g-button>
    </div>

    <div class="header-infoCliente-conteudo espacamento-fluxos">
      <div class="cliente-cnpj">
        <div class="cnpj-titulo titulo-conteudo-fluxos"> CNPJ </div>
        <PInputText
          class="cnpj-input input-label"
          :value="this.objForm.cnpj"
          disabled
        />
      </div>

      <div class="cliente-codigo">
        <div class="codigo-titulo titulo-conteudo-fluxos"> Código </div>
        <PInputText
          class="codigo-input input-label"
          :value="this.objForm.codigoExterno"
          disabled
        />
      </div>

      <div class="cliente-razao-social">
        <div class="razao-social-titulo titulo-conteudo-fluxos"> Razão Social </div>
        <PInputText
          class="razao-social-input input-label"
          :value="this.objForm.razaoSocial"
          disabled
        />
      </div>

      <div class="cliente-estado">
        <div class="estado-titulo titulo-conteudo-fluxos"> Estado </div>
        <PInputText
          class="estado-input input-label"
          :value="this.objForm.nomeEstado"
          disabled
        />
      </div>

      <div class="cliente-cidade">
        <div class="cidade-titulo titulo-conteudo-fluxos"> Cidade </div>
        <PInputText
          class="cidade-input input-label"
          :value="this.objForm.nomeCidade"
          disabled
        />
      </div>

      <div class="cliente-segmento">
        <div class="segmento-titulo titulo-conteudo-fluxos"> Segmento </div>
        <PInputText
          class="segmento-input input-label"
          :value="this.objForm.clienteTipoTexto"
          disabled
        />
      </div>

      <div class="cliente-contato">
        <div class="contato-titulo titulo-conteudo-fluxos"> Contato </div>
        <PInputText
          class="contato-input input-label"
          :value="this.objForm.nomeContato"
          disabled
        />
      </div>

      <div class="cliente-telefone">
        <div class="telefone-titulo titulo-conteudo-fluxos"> Telefone </div>
        <PInputText
          class="telefone-input input-label"
          :value="this.objForm.numeroTelefone == 0 ? '-' : this.objForm.numeroTelefone"
          disabled
        />
      </div>

      <div class="cliente-ramal">
        <div class="ramal-titulo titulo-conteudo-fluxos"> Ramal </div>
        <PInputText
          class="ramal-input input-label"
          :value = "this.objForm.numeroRamal || '-'"
          disabled
        />
      </div>

      <div class="cliente-suframa">
        <div class="suframa-titulo titulo-conteudo-fluxos"> Suframa </div>
        <PInputText
          class="suframa-input input-label"
          :value="this.objForm.numeroSuframa"
          disabled
        />
      </div>

      <div class="cliente-incentivo-fiscal">
        <div class="incentivo-titulo titulo-conteudo-fluxos"> Possui incentivo fiscal? </div>
        <PInputText
          class="incentivo-input"
          :value="this.ICMS + this.IPI + this.PisCofins == '' ? 'NÃO' : this.ICMS + this.IPI + this.PisCofins"
          disabled
        />
      </div>
    </div>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="step2" 
        >
          CONTINUAR
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="paginainicial" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja editar as informações do cliente? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopup"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="modificar"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
    <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import InfoClienteRepeticao from "./InfoClienteRepeticao.js";
export default InfoClienteRepeticao;
</script>

<style scoped>
.header-infoCliente-btnEditar {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media (min-width:310px) {
  .header-infoCliente-conteudo {
  display: grid;
  grid-template-columns: minmax(4em, 1fr);
  grid-template-rows: repeat(11, auto);
  grid-column-gap: 20px;
  grid-row-gap: 14px;
}

.buttons-next-back {
  margin: 50px 20px 30px;
}
}

@media (min-width:368px) {
.header-infoCliente-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(8, auto);
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 3; }
.cliente-codigo { grid-area: 2 / 1 / 3 / 3; }
.cliente-razao-social { grid-area: 3 / 1 / 4 / 3; }
.cliente-estado { grid-area: 4 / 1 / 5 / 2; }
.cliente-cidade { grid-area: 4 / 2 / 5 / 3; }
.cliente-segmento { grid-area: 5 / 1 / 6 / 2; }
.cliente-contato { grid-area: 5 / 2 / 6 / 3; }
.cliente-telefone { grid-area: 6 / 1 / 7 / 3; }
.cliente-ramal { grid-area: 7 / 1 / 8 / 2; }
.cliente-suframa { grid-area: 7 / 2 / 8 / 3; }
.cliente-incentivo-fiscal { grid-area: 8 / 1 / 9 / 3; text-align: justify;}
}

@media (min-width:400px) {
.buttons-next-back {
  margin: 50px 0 30px;
}
}

@media (min-width:600px) {
.header-infoCliente-conteudo {
  grid-template-rows: repeat(7, auto);
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 2 / 1 / 3 / 3; }
.cliente-estado { grid-area: 3 / 1 / 4 / 2; }
.cliente-cidade { grid-area: 3 / 2 / 4 / 3; }
.cliente-segmento { grid-area: 4 / 1 / 5 / 2; }
.cliente-contato { grid-area: 4 / 2 / 5 / 3; }
.cliente-telefone { grid-area: 5 / 1 / 6 / 2; }
.cliente-ramal { grid-area: 5 / 2 / 6 / 3; }
.cliente-suframa { grid-area: 6 / 1 / 7 / 2; }
.cliente-incentivo-fiscal { grid-area: 6 / 2 / 7 / 3; }
}

@media (min-width:801px) {

}

@media (min-width:1025px) {
.header-infoCliente-btnEditar { padding: 0 50px; }

.header-infoCliente-conteudo {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
}

.cliente-cnpj { grid-area: 1 / 1 / 2 / 3; }
.cliente-codigo { grid-area: 1 / 3 / 2 / 5; }
.cliente-razao-social { grid-area: 1 / 5 / 2 / 7; }
.cliente-estado { grid-area: 2 / 1 / 3 / 2; }
.cliente-cidade { grid-area: 2 / 2 / 3 / 3; }
.cliente-segmento { grid-area: 2 / 3 / 3 / 5; }
.cliente-contato { grid-area: 2 / 5 / 3 / 7; }
.cliente-telefone { grid-area: 3 / 1 / 4 / 3; }
.cliente-ramal { grid-area: 3 / 3 / 4 / 4; }
.cliente-suframa { grid-area: 3 / 4 / 4 / 5; }
.cliente-incentivo-fiscal { grid-area: 3 / 5 / 4 / 7; }
}

@media (min-width:1281px) {
.header-infoCliente-btnEditar { padding: 0 130px; }
}

@media (min-width:1500px) {
.header-infoCliente-btnEditar { padding: 0 150px; }
}
</style>
